<template>
	<div class="error hello-wrapper">
		<div class="panel white-tilted-1">
			<div class="instructions">
				<p>
					<strong class="name">Olá {{ simulado.PrimeiroNome }},</strong>
				</p>
				<p>
					{{ message }}
				</p>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>

</style>

<script>
	export default {
		props: ['simulado'],

		computed: {
			message() {

				if(this.simulado.Bloqueado) {
					return "O seu acesso ao simulado foi bloqueado."
				}

				if(!this.simulado.PodeIniciar) {
					return "O período de realização do simulado ainda não começou."
				}

				if(this.simulado.PrazoAcabou) {
					return "O prazo para realização do simulado terminou."
				}

				if(this.simulado.TempoAcabou) {
					return "Você utilizou todo o tempo disponível para a realização do simulado."
				}

				if(this.simulado.SuperouLimiteAcessos) {
					return "Você acessou mais do que o limite permitido."
				}

				return "";
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/result/error.vue